import Vue from 'vue';
import BackendErrors from './BackendErrors.vue';
import ConfirmModal from './ConfirmModal.vue';
import ColorPicker from './ColorPicker.vue';
import Paginator from './Paginator.vue';
import Skeleton from './Skeleton.vue';
import TextArea from './TextArea.vue';
import Datetime from './Datetime.vue';
import Message from './Message.vue';
import Button from './Button.vue';
import Loader from './Loader.vue';
import Input from './Input.vue';
import Select from './Select.vue';
import Modal from './Modal.vue';

Vue.component('base-modal', Modal);
Vue.component('base-input', Input);
Vue.component('base-select', Select);
Vue.component('base-loader', Loader);
Vue.component('base-button', Button);
Vue.component('base-message', Message);
Vue.component('base-skeleton', Skeleton);
Vue.component('base-datetime', Datetime);
Vue.component('base-text-area', TextArea);
Vue.component('base-paginator', Paginator);
Vue.component('base-color-picker', ColorPicker);
Vue.component('base-confirm-modal', ConfirmModal);
Vue.component('base-backend-errors', BackendErrors);
